module.exports = __webpack_public_path__ + "static/media/included4.366deaef.svg";